import { FixedDistributionAccount, appliesTo, } from '../../fixed-distributions/index.js';
import { dayIn } from './dates.js';
import { replayAssociation, replayCase } from './replay.js';
const debtorDistributions = (fixedDistributions) => fixedDistributions.filter(appliesTo(FixedDistributionAccount.Debtor));
const engineOptions = (policy, options) => {
    const day = dayIn(policy.timezone);
    return {
        appendHist: options.appendHist,
        breakPointCallBack: options.breakPointCallBack,
        monthStartBreakpoints: options.monthStartBreakpoints,
        limitationFrozenAt: options.freezeLimitation === true ? day(new Date()) : undefined,
        writeOffAccruals: options.writeOffAccruals,
        costCeiling: options.costCeiling,
    };
};
const engineCase = (input) => ({
    ...input,
    fixedDistributions: debtorDistributions(input.fixedDistributions),
    options: engineOptions(input.policy, input.options),
    // Only cases in an association carry joint vouchers.
    associated: input.caseVouchers.some((voucher) => voucher.associationId != null),
});
const singleCase = (caseVouchers, documents, policy, fixedDistributions, options) => engineCase({
    caseId: caseVouchers[0]?.caseId ?? '',
    caseVouchers,
    documents,
    fixedDistributions,
    policy,
    options,
});
// Read mode: one case, with joint allocations read from its persisted
// distributions.
export const calculateV2 = async (caseVouchers, documents, policy, fixedDistributions, untilISOString, options) => {
    const result = await replayCase(singleCase(caseVouchers, documents, policy, fixedDistributions, options), untilISOString);
    return result.caseVouchers;
};
// Every voucher's amount as of each of `times` (ascending), from one replay.
export const amountsOverTime = (caseVouchers, documents, policy, fixedDistributions, untilISOString, times, options) => {
    const input = singleCase(caseVouchers, documents, policy, fixedDistributions, options);
    return replayCase({ ...input, options: { ...input.options, snapshotTimes: times } }, untilISOString);
};
// Derive mode: replays every case of an association as one timeline and
// decides which part of each joint payment applies on every other case.
export const deriveAssociation = (cases, untilISOString) => replayAssociation(cases.map(engineCase), untilISOString);
//# sourceMappingURL=index.js.map